/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { EsercentePraticaBackofficeRowDTO } from './esercente-pratica-backoffice-row-dto';


export interface PagedModelEsercentePraticaBackofficeRowDTO { 
    content?: Array<EsercentePraticaBackofficeRowDTO>;
    page?: PageMetadata;
}

